import { render, staticRenderFns } from "./drawer.vue?vue&type=template&id=83aa1666"
import script from "./drawer.vue?vue&type=script&lang=js"
export * from "./drawer.vue?vue&type=script&lang=js"
import style0 from "./drawer.vue?vue&type=style&index=0&id=83aa1666&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports